import { useEffect, useState } from "react";

const KEY = "vinko-cookie-consent";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const v = localStorage.getItem(KEY);
    if (!v) setShow(true);
  }, []);

  const set = (val) => {
    localStorage.setItem(KEY, val);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed inset-x-3 bottom-3 sm:inset-x-6 sm:bottom-6 z-40 max-w-3xl mx-auto rounded-2xl border border-white/10 bg-black/90 backdrop-blur-xl p-5 sm:p-6 shadow-2xl"
    >
      <p className="text-sm text-zinc-300 leading-relaxed">
        Utilizziamo cookie tecnici e, previo consenso, cookie analitici e di
        profilazione per migliorare la tua esperienza sul sito e offrirti
        contenuti in linea con le tue preferenze. Puoi accettare, rifiutare o
        personalizzare la tua scelta. Consulta la nostra{" "}
        <a href="/cookie" className="text-yellow-400 underline">
          Cookie Policy
        </a>
        .
      </p>
      <div className="mt-4 flex flex-col sm:flex-row gap-2">
        <button
          data-testid="cookie-accept"
          onClick={() => set("all")}
          className="flex-1 rounded-full bg-yellow-400 hover:bg-yellow-300 text-black font-bold py-2.5 text-sm transition-colors duration-200"
        >
          Accetta tutti
        </button>
        <button
          data-testid="cookie-reject"
          onClick={() => set("essential")}
          className="flex-1 rounded-full border border-white/15 hover:border-yellow-400 hover:text-yellow-400 text-white font-medium py-2.5 text-sm transition-colors duration-200"
        >
          Solo essenziali
        </button>
      </div>
    </div>
  );
}
